import { ChevronDown } from '@untitledui/icons';
import { useCallback } from 'react';

import { cx } from '@/utils/cx';

interface NavSectionToggleProps {
  sectionId: string;
  sectionLabel: string;
  isExpanded: boolean;
  controlsId?: string;
  onToggle: (sectionId: string) => void;
}

export function NavSectionToggle({
  sectionId,
  sectionLabel,
  isExpanded,
  controlsId,
  onToggle,
}: NavSectionToggleProps) {
  const handleClick = useCallback(
    () => onToggle(sectionId),
    [onToggle, sectionId]
  );

  return (
    <button
      type='button'
      onClick={handleClick}
      aria-expanded={isExpanded}
      aria-controls={controlsId}
      aria-label={`${isExpanded ? 'Collapse' : 'Expand'} ${sectionLabel}`}
      className={cx(
        'flex size-7 shrink-0 items-center justify-center rounded-md text-fg-quaternary transition-colors hover:bg-primary_hover hover:text-secondary outline-focus-ring focus-visible:outline-2 focus-visible:outline-offset-2'
      )}
    >
      <ChevronDown
        aria-hidden='true'
        className={cx(
          'size-4 shrink-0 transition-transform duration-100 motion-reduce:transition-none',
          !isExpanded && '-rotate-90'
        )}
      />
    </button>
  );
}
